import { Card, CardContent, CardDescription, CardHeader, CardMeta, Image } from "semantic-ui-react";
import styles from './TrufflePage.module.css';
export default function CardTruffle1() {

    return (
        <Card fluid className={styles.cardShadow}>
            <CardContent>
                <CardHeader>Fresh White Truffle - Tuber Magnatum Pico</CardHeader>
                <CardMeta>
                    <Image src="/assets/magnatum.png" fluid centered />
                </CardMeta>
                <CardDescription>

                </CardDescription>
            </CardContent>
            <CardContent extra>
                <span className={styles.price}>4000 </span>-<span className={styles.price}>16000 </span>
            </CardContent>
        </Card>
    )
}